import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SkeletonLayout from "./Skeleton";
import { useDispatch, useSelector } from "react-redux";
import { getAllCategory } from "../features/products/productSlilce";

const Layout = () => {
    const dispatch = useDispatch();
     const productCategory = useSelector((state) => state?.product?.category.map((item)=>item));
       useEffect(() => {
         dispatch(getAllCategory())
       }, []);
     
  return (
  <>
  
{productCategory?.length<1 ? <SkeletonLayout /> :    <>
      <Header />
      <Outlet />
      <Footer />
      <ToastContainer
        position="bottom-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
          toastClassName="my-toast"  // 👈 apply custom class

        
      />
    </>}
    </>
  );
};

export default Layout;
